import { BankBicLogos } from 'src/app/@shared/enums/bank-bic-codes.enum';
import { ModelBase } from '../../abstract/model-base.model';
import { Country } from '../../core/country.model';

export class Bank extends ModelBase {

    static override CLASS_NAME: string = 'Bank';

    private _bic!: string;
    private _commercialName!: string;
    private _country!: Country;
    private _csv!: boolean;
    private _name!: string;
    private _supportsOpenBanking!: boolean;

    /**
     * Retourne l'initiale de la banque (nom commercial, à défaut raison sociale) pour l'avatar de repli
     */
    public getInitial(): string {
        const label = this.commercialName || this.name;
        return label ? label.charAt(0).toUpperCase() : '?';
    }

    /**
     * Retourne le chemin du logo de la banque ou null si aucun logo n'existe
     */
    public getLogo(): string | null {
        if (!this.bic) {
            return null;
        }
        const logoFilename = BankBicLogos[this.bic];
        return logoFilename ? `assets/images/images/${logoFilename}` : null;
    }

    public get bic(): string {
        return this._bic;
    }

    public set bic(value: any) {
        this._setValue('_bic', value, 'string');
    }

    public get commercialName(): string {
        return this._commercialName;
    }

    public set commercialName(value: any) {
        this._setValue('_commercialName', value, 'string');
    }

    public get country(): Country {
        return this._country;
    }

    public set country(value: any) {
        this._setValue('_country', value, 'Country');
    }

    public get csv(): boolean {
        return this._csv;
    }

    public set csv(value: any) {
        this._setValue('_csv', value, 'boolean');
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: any) {
        this._setValue('_name', value, 'string');
    }

    public get supportsOpenBanking(): boolean {
        return this._supportsOpenBanking;
    }

    public set supportsOpenBanking(value: any) {
        this._setValue('_supportsOpenBanking', value, 'boolean');
    }

}
